import React, { ReactNode } from 'react';
import { useI18nTimeFormat } from '@/hooks/useI18nTimeFormat';

interface PolicyItemProps {
  avatar: ReactNode;
  title: string;
  datetime?: number;
  onClick?: () => void;
}

export const PolicyItem = ({
  avatar,
  title,
  datetime,
  onClick,
}: PolicyItemProps) => {
  const { tFormat } = useI18nTimeFormat();
  return (
    <div className="flex h-[70px] cursor-pointer" onClick={onClick}>
      {avatar && <div className="flex-shrink-0 mr-4">{avatar}</div>}
      <div className="flex-1 flex flex-col overflow-hidden">
        <p className="text-p2-semibold text-neutral-text2 h-48 line-clamp-2">
          {title}
        </p>
        <span className="text-p0 font-semibold text-neutral-text4 mt-4">
          {datetime && tFormat(datetime, 'L')}
        </span>
      </div>
    </div>
  );
};
